"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcRentalFormContracts = void 0;
const UcRentalFormContracts_yaml_component_1 = __importDefault(require("./UcRentalFormContracts.yaml?component"));
exports.UcRentalFormContracts = UcRentalFormContracts_yaml_component_1.default;
